// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__29ggx","boxTitle":"Qualiphy_boxTitle__2rsWL","box":"Qualiphy_box__-m4Hb","toggleWrap":"Qualiphy_toggleWrap__33iB1"};